<div class="progress-loader" [hidden]="!loading"> 
    <aur-loading-spinner color="primary" context="page" ></aur-loading-spinner>    
</div>